import { fetchPath } from '@/utils/api'
import { URL } from '@/constants/api'
import requireAuthentication from '../../utils/requireAuthentication'
import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import lines from './lines'
import changes from './changes'

export default {
  namespaced: true,
  state,
  mutations,
  actions: actions({ apiUrl: URL, fetchPath, requireAuthentication }),
  getters,
  modules: { lines, changes },
}
